var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',_vm._g(_vm._b({staticClass:"form-input"},'textarea',_vm.$props,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }